import React from 'react'
import { formatMoney } from '../utils/formatMoney'

export function FinanceStatsCards({ stats, profile, onPageChange }) {
  if (!stats.financeStats || profile?.role !== 'owner') return null

  return (
    <div className="dashboard-section animate-fade-in" data-tour="dashboard-finance-stats">
      <div className="dashboard-section-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
        Финансовый результат
      </div>
      <div className="dashboard-stats-grid">
        <div className="dashboard-card clickable-card card-income" onClick={() => onPageChange('analytics')}>
          <div className="card-header">
            <span className="card-title">Доход ПВЗ</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"/>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
              </svg>
            </span>
          </div>
          <div className="card-value">{formatMoney(stats.financeStats.totalIncome)}</div>
          <div className="card-footer">Подробнее в аналитике →</div>
        </div>

        <div className="dashboard-card clickable-card card-payroll" onClick={() => onPageChange('payments')}>
          <div className="card-header">
            <span className="card-title">ФОТ</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </span>
          </div>
          <div className="card-value">{formatMoney(stats.financeStats.totalPayroll)}</div>
          <div className="card-footer">График выплат →</div>
        </div>

        <div className="dashboard-card clickable-card card-expenses" onClick={() => onPageChange('analytics')}>
          <div className="card-header">
            <span className="card-title">Расходы + Налог</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/>
                <polyline points="17 18 23 18 23 12"/>
              </svg>
            </span>
          </div>
          <div className="card-value">{formatMoney(stats.financeStats.totalExpenses)}</div>
          <div className="card-footer">Подробнее в аналитике →</div>
        </div>

        <div className="dashboard-card clickable-card card-profit" onClick={() => onPageChange('analytics')}>
          <div className="card-header">
            <span className="card-title">Чистая прибыль</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </span>
          </div>
          <div className="card-value">{formatMoney(stats.financeStats.netProfit)}</div>
          <div className="card-footer">Подробнее в аналитике →</div>
        </div>
      </div>
    </div>
  )
}
